import styles from "./Instruction.module.css"

const InstructionsContent = ({ instructions }: { instructions: string }) => (
  <div
    className={styles.Instruction}
    dangerouslySetInnerHTML={{
      __html: instructions,
    }}
  />
)

export default InstructionsContent
